import navBarStyle from "../../styles/nav.module.scss";

export default function MobileChromeBar({
  onLogoClick,
  onClose,
  closeLabel = "Close",
  fixed = false,
  logoLinked = true,
  compact = false,
}) {
  const isLogoLinked = Boolean(logoLinked && onLogoClick);

  return (
    <div
      className={`${navBarStyle.mobileChromeBar} ${
        fixed ? navBarStyle.bar : ""
      } ${compact ? navBarStyle.mobileChromeBarCompact : ""}`}
    >
      <div
        className={navBarStyle.logo}
        onClick={isLogoLinked ? onLogoClick : undefined}
        onKeyDown={
          isLogoLinked
            ? (event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onLogoClick();
                }
              }
            : undefined
        }
        role={isLogoLinked ? "link" : undefined}
        tabIndex={isLogoLinked ? 0 : undefined}
      >
        MATLIB
      </div>
      {onClose ? (
        <button
          type="button"
          className={navBarStyle.mobileCloseButton}
          onClick={onClose}
        >
          {closeLabel}
        </button>
      ) : null}
    </div>
  );
}
